export default "__VITE_ASSET__e41a4053__"